export const AWS_SERVER_ENDPOINT = "https://dxe10e17rf.execute-api.us-east-1.amazonaws.com/dev-admin";
 
export const AWS_SERVER_ENDPOINT_2 = "https://dxe10e17rf.execute-api.us-east-1.amazonaws.com/dev-admin";

export const AWS_LOCAL_SERVER_ENDPOINT = "http://localhost:3000/dev-2";

export const FLOW_MARKET_NFT_API = '';
